// Заглушка, которую SEO-форма годами писала в notes.seoUrl как значение
// (а не placeholder) — в проде таких записей десятки тысяч. Адресом её
// считать нельзя.
const LEGACY_URL_PLACEHOLDER = 'http://website.com'

/**
 * OCT-4991: адрес страницы теперь только node.url. Возвращает значение,
 * которое надо перенести из старого notes.seoUrl, или null — если переносить
 * нечего (адрес уже есть, поля нет, или там заглушка).
 */
export const legacySeoUrlToAdopt = (
  url: string | null | undefined,
  seoUrl: string | null | undefined
): string | null => {
  if (url !== null && url !== undefined && url !== '') {
    return null
  }

  const legacy = seoUrl?.trim()

  if (!legacy || legacy === LEGACY_URL_PLACEHOLDER) {
    return null
  }

  return legacy
}
